import React from 'react'
import Dialog from 'components/shared/Dialog'
import Box from '@mui/material/Box'
import sx from './styles'

const SpinCar = (props) => {
  const {
    open, onClose, url,
  } = props

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={sx.modal}
      iconClosebutton
    >
      <Box sx={sx.iframe}>
        <iframe
          id="spincar-iframe"
          src={`${url}!lang=es!hidecarousel`}
          title="spincar title"
          frameBorder="0"
        />
      </Box>
    </Dialog>
  )
}

export default SpinCar
